export const checkSharedLiquidity = (
  isSharedLiquidityEnabled: boolean,
  siteMask: number | undefined,
  currentSite: number
): boolean => isSharedLiquidityEnabled || siteMask === currentSite;
